import { render } from "./QuestionDetails.vue?vue&type=template&id=9ff81cda"
import script from "./QuestionDetails.vue?vue&type=script&lang=js"
export * from "./QuestionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__